import BaseRepository from './base.repository';

class MedicationRemindersRepository extends BaseRepository {
  constructor() {
    super('/medication-reminders');
  }

  find() {
    return this.client.get('');
  }

  create(request) {
    return this.client.post('', request);
  }

  update(itemUnique, request) {
    return this.client.patch(`/${itemUnique}`, request);
  }

  remove(itemUnique) {
    return this.client.delete(`/${itemUnique}`);
  }

  respond(itemUnique, request) {
    return this.client.post(`/occurrences/${itemUnique}/actions`, request);
  }
}

export default new MedicationRemindersRepository();
